<ng-container *transloco="let t; read: 'home'">
  <h1>{{ t('crbp') }}</h1>
  <h2>{{ t('title') }}</h2>
  <div class="content">
    <div>
      <p>{{ t('info1') }}</p>
      <p>{{ t('info2') }}</p>
      <p>{{ t('info3') }}</p>
      <p>{{ t('info4') }}</p>
      <ul>
        <li>{{ t('info-list-1') }}</li>
        <li>{{ t('info-list-2') }}</li>
        <li>{{ t('info-list-3') }}</li>
      </ul>
      <div class="help-card">
        <div class="help-title">{{ t('help-contact.title') }}</div>
        <div class="help-info">
          <ng-container *ngIf="translationService.getActiveLang() === 'fr'">
            {{ t('help-contact.page-1') }}
          </ng-container>

          <a routerLink="/help" [queryParams]="{ lang: translationService.getActiveLang() }" target="_blank">{{
            t('help-contact.page')
          }}</a>
          {{ t('help-contact.page-2') }}
        </div>
        <div class="contact-tel">
          <div>{{ t('help-contact.body') }}</div>
          <a href="tel:+3226860160">+32 (0)2 686 01 60</a>
          <div>{{ t('help-contact.info') }}</div>
        </div>
      </div>
    </div>
    <div class="cards">
      <a class="card" (click)="navigateToLoginUrl(LoginType.Citizen)" (keydown.enter)="navigateToLoginUrl(LoginType.Citizen)" tabindex="0">
        <div class="card-title">{{ t('citizen-card-title') }}</div>
        <img src="assets/logo/citizen.svg" alt="citizen icon" />
      </a>
      <a class="card" (click)="chooseLawyerLoginOption()" (keydown.enter)="chooseLawyerLoginOption()" tabindex="0">
        <div class="card-title">{{ t('lawyer-card-title') }}</div>
        <img class="resize" src="assets/logo/lawyer.svg" alt="lawyer icon" />
      </a>
      <a class="card" (click)="navigateToLoginUrl(LoginType.Organisation)" (keydown.enter)="navigateToLoginUrl(LoginType.Organisation)" tabindex="0">
        <div class="card-title">{{ t('organisation-card-title') }}</div>
        <img class="resize" src="assets/logo/organisation.svg" alt="organisation icon" />
      </a>
      <a class="card justice-card" (click)="navigateToLoginUrl(LoginType.Justice)" (keydown.enter)="navigateToLoginUrl(LoginType.Justice)" tabindex="0">
        <div class="card-title">{{ t('justice-card-title') }}</div>
        <img src="assets/imgs/justice-logo.svg" alt="Justice icon" />
      </a>
    </div>
  </div>

  <ng-template #lawyerLoginDialog>
    <div class="lawyer-login-dialog">
      <mat-icon class="close" mat-dialog-close fontIcon="close"></mat-icon>
      <div class="lawyer-login-options">
        <a class="lawyer-login-option" (click)="navigateToLoginUrl(LoginType.LawyerCard)" (keydown.enter)="navigateToLoginUrl(LoginType.LawyerCard)" tabindex="0">
          <div>{{ t('lawyer-card') }}</div>
        </a>
        <a class="lawyer-login-option" (click)="navigateToLoginUrl(LoginType.Lawyer)" (keydown.enter)="navigateToLoginUrl(LoginType.Lawyer)" tabindex="0">
          <div>{{ t('lawyer-eid') }}</div>
        </a>
        <a class="lawyer-login-option" (click)="navigateToLoginUrl(LoginType.Staff)" (keydown.enter)="navigateToLoginUrl(LoginType.Staff)" tabindex="0">
          <div>{{ t('lawyer-staff') }}</div>
        </a>
      </div>
    </div>
  </ng-template>
</ng-container>
